module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.features.length) ? _c('div', {
    staticClass: "features"
  }, _vm._l((_vm.features), function(f) {
    return _c('div', {
      key: f.text,
      staticClass: "feature",
      class: {
        animated: _vm.animated
      }
    }, [_c('div', {
      staticClass: "img-wrap"
    }, [_c('img', {
      attrs: {
        "src": f.imageUrl,
        "alt": "share icon"
      }
    })]), _vm._v("\n      " + _vm._s(f.text) + "\n    ")])
  }), 0) : _vm._e()
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-291fc0e0", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-291fc0e0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./scripts/src/components/referral/how-it-works-features.vue
// module id = 753
// module chunks = 0